
import { UseFormReturn } from "react-hook-form";
import { JobFormValues } from "../schemas/jobFormSchema";
import { JobFormFields } from "./JobFormFields";

interface JobFormContentProps {
  form: UseFormReturn<JobFormValues>;
  clientName?: string;
}

export function JobFormContent({ form, clientName }: JobFormContentProps) {
  return (
    <div className="space-y-6">
      <JobFormFields form={form} clientName={clientName} />
    </div>
  );
}
